// extracted by mini-css-extract-plugin
export default {"info":"delete-modal_info__IW5za","text":"delete-modal_text__n7tRR","source":"delete-modal_source__vCBSg","button":"delete-modal_button__DnnfX"};